import React, { useEffect, useState } from 'react';
import RFB from 'novnc-core'
import { Button, IconButton, List, ListItem, ListItemIcon, ListItemText, TextField } from '@mui/material';
import { toast } from 'react-toastify';
import socket from "../../socket";
import { AppStore } from '../../stores/AppStore';
import { copyToClipboard } from '../../utils';
import { AppIcon } from '../utils/AppIcon';

const socket_vnc = socket.channel("vnc:");
const ScreenSizeDetector = require('screen-size-detector');
const screen = new ScreenSizeDetector();

socket_vnc.join()
  .receive("ok", resp => {
    console.log("Bem vindo 1", resp)
  })
  .receive("error", resp => {
    console.log("Error", resp)
  })

const VncPage = ({ }) => {

  const rfbRef = React.useRef(null)
  const containerRef = React.useRef(null)
  const [hostsOnline, setHostsOnline] = useState([]);
  const [hostName, setHostName] = useState("");
  const hostNameRef = React.useRef("")
  const [search, setSearch] = useState('');
  const [viewOnly, setViewOnly] = useState(true);

  useEffect(() => {

    hostNameRef.current = hostName

  }, [hostName]);

  useEffect(() => {
    AppStore.setTitle("VNC");

    disconnectRFB();

    socket_vnc.on("online", payload => {

      console.log("online: ", payload)

      setHostsOnline((prevHosts) => {

        const exists = prevHosts.some((host) => host.task_id === payload.task_id);

        if (payload.status === 1) {

          if (!exists) {
            return [...prevHosts, payload];
          }

          return prevHosts;

        } else {

          if (hostNameRef.current == payload.task_id) disconnectRFB()

          return prevHosts.filter((host) => !(host.task_id === payload.task_id));

        }

      });

    })

    return () => {

      socket_vnc.off('vnc:');

    };

  }, []);

  const connectRFB = (port: string, ip: string, task_id: string) => {

    if(!ip) return toast.error('IP é necessário para se conectar.');
    if(!port) return toast.error('Porta é necessária para se conectar.');

    const password = "@brasil123"

    try {

      const rfb = new RFB(containerRef.current, `ws://${ip}:${port}/websockify`, {
        credentials: { password: password },
        shared: true,
        repeaterID: "",
      });

      rfbRef.current = rfb;

      rfb.viewOnly = viewOnly;
      rfb.scaleViewport = true;
      rfb.resizeSession = true;

      rfb.addEventListener('connect', () => {
        toast.success('Conectado.');
        setHostName(task_id)
      });

      rfb.addEventListener('disconnect', (e) => {
        // toast.error('Conexão com VNC encerrada ou falhou.');
      });

      rfb.addEventListener('securityfailure', (e) => {
        // toast.error('Falha de segurança: senha errada ou acesso negado.');
      });

    } catch (exc) {

      toast.error("Failed to connect to server");
      setHostName("")
      return;

    }

  };

  const disconnectRFB = () => {

    if (rfbRef.current) {
      rfbRef.current.disconnect();
      rfbRef.current = null;
    }

    setHostName("")

    setTimeout(() => { }, 500);

  };

  const reconnect = (port: string, ip: string, task_id: string) => {

    disconnectRFB();

    connectRFB(port, ip, task_id);

  };

  const handleFullscreen = () => {

    const elem = containerRef.current;

    if (elem.requestFullscreen) {

      elem.requestFullscreen();

    } else if (elem.webkitRequestFullscreen) {

      elem.webkitRequestFullscreen();

    } else if (elem.msRequestFullscreen) {

      elem.msRequestFullscreen();

    }

  };

  const filteredHosts = hostsOnline.filter((host) =>

    `${host.hostname}:${host.port} ${host.task_id}`.toLowerCase().includes(search.toLowerCase())

  );

  const liberarVNC = () => {

    setViewOnly(!viewOnly)

    disconnectRFB();

  };

  const copyChave = (token: string) => {

    copyToClipboard(token);

    toast.success('Task ID copiada com sucesso!', {});

  }

  return (
    <div style={{ display: "flex" }}>

      <div style={{ textAlign: "left", minWidth: 420 }}>

        <ListItem style={{ paddingLeft: 0 }}><ListItemText><b>Containers</b></ListItemText></ListItem>

        <ListItem style={{ padding: 0, paddingRight: 5 }}>
          <TextField
            fullWidth
            size="small"
            placeholder="Buscar host..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            variant="filled"
          />
        </ListItem>

        <List component="div" disablePadding sx={{ padding: "0px 10px 0px 0px", overflow: "auto", maxHeight: (screen.height - 380) }}>

          {filteredHosts.map(value => {
            return (
              <ListItem style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: "1px solid rgba(204, 204, 204, 0.13)" }}>
                <span
                  onClick={() => reconnect(value.port, value.ip, value.task_id)}
                  className="list-item-bot"
                >
                  <ListItemIcon style={{ minWidth: 30, display: 'flex', alignItems: 'center' }}>
                    {hostName == value.task_id ? (
                      <AppIcon size={18} name="live_tv" style={{ color: "#3579ea",}} />
                    ) : (
                      <AppIcon size={18} name="tv" />
                    )}
                  </ListItemIcon>

                  <ListItemText>
                    <span style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
                      {value.hostname}:{value.port}<br />{value.task_id}
                    </span>
                  </ListItemText>
                </span>

                <IconButton
                  onClick={() => copyChave(value.task_id)}
                  style={{ marginLeft: 'auto' }}
                >
                  <AppIcon name="content_paste" size={18} style={{ color: "#3579ea" }} />
                </IconButton>

              </ListItem>
            );
          })}
        </List>

      </div>

      <div style={{ width: "100%", textAlign: "right" }}>

        <Button
          variant="outlined"
          startIcon={viewOnly ? <AppIcon size={20} name="check_box_outline_blank" /> : <AppIcon size={20} name= "check_box" />}
          onClick={liberarVNC}
          style={{ marginBottom: '10px', marginRight: '10px' }}
          className={viewOnly ? '' : 'btn-liberado-vnc'}
        >
          {viewOnly ? "Liberar VNC" : "VNC Liberado"}
        </Button>

        <Button
          variant="outlined"
          startIcon={<AppIcon size={20} name="desktop_access_disabled" />}
          onClick={disconnectRFB}
          style={{ marginBottom: '10px', marginRight: '10px' }}
        >
          Desconectar
        </Button>

        <Button
          variant="outlined"
          startIcon={<AppIcon size={20} name="fullscreen" />}
          onClick={handleFullscreen}
          style={{ marginBottom: '10px' }}
        >
          Fullscreen
        </Button>

        <div
          ref={containerRef}
          style={{
            width: '100%',
            height: (screen.height - 330),
            border: '1px solid #ccc',
          }}
        />
      </div>

    </div>
  );

}

export default VncPage;
